import React, {useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export const AutoComplete = ({options, name, label, onChange, defaultValue, ...restProps}) => {
  const handleChange = (label) => {
    onChange({target: {name: name, value: label}})
  }
  useEffect(()=> {
    if (defaultValue) {
      handleChange(defaultValue)
    }
  },[])
  return (
    <Autocomplete
      {...restProps}
      name={name}
      id="combo-box-demo"
      options={options}
      defaultValue={defaultValue}
      getOptionLabel={(option) => option}
      onInputChange={(event, newInputValue) => {
        handleChange(newInputValue)
      }}
      style={{ width: 300 }}
      renderInput={(params) => <TextField {...params} label={label} variant="outlined" />}
    />
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
  { title: "Schindler's List", year: 1993 },
  { title: 'Pulp Fiction', year: 1994 },
  { title: 'The Lord of the Rings: The Return of the King', year: 2003 },
  { title: 'The Good, the Bad and the Ugly', year: 1966 },
  { title: 'Fight Club', year: 1999 },
  { title: 'The Lord of the Rings: The Fellowship of the Ring', year: 2001 },
  { title: 'Star Wars: Episode V - The Empire Strikes Back', year: 1980 },
];